var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"diagramContainer",attrs:{"src":_vm.$options.sandboxFrameSrc,"sandbox":_vm.$options.sandboxAttributes,"frameborder":"0","scrolling":"no","width":"100%","height":_vm.iframeHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }